/* eslint-disable indent */
import styled from 'styled-components'

export const Style = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin: ${props => props.marginTop || '350px'} 0 20px 0;
  > img {
    position: absolute;
    bottom: 0;
    z-index: -1;
    width: 100%;
    left: 0;
    right: 0;
  }
  .card {
    box-shadow: ${props =>
      props.boxShadow || '0 10px 10px 0 rgba(255, 115, 0, 0.2)'};
    border: ${props => props.border || ' solid 1px #e3dbff'};
    background-color: #fff;
    padding: 40px;
    .tag {
      font-family: 'Open Sans';
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ff7400;
      margin-bottom: 40px;
    }
    .title {
      font-family: 'Open Sans';
      margin-bottom: 10px;
      font-size: 30px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #333333;
    }
  }
  .join {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    > a {
      text-decoration: none;
      border-radius: 22.5px;
      background: ${props =>
        props.buttonColor ||
        'linear-gradient(270deg, #ff9700 0%, #ff7400 100%)'};
      padding: 13px 10px;
      width: 239px;
      display: flex;
      justify-content: space-around;
      font-size: 14px;
      color: white;
      outline: none;
      border: unset;
      align-items: center;
      color: #ffffff;
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      font-weight: 600;
      line-height: 19px;
    }
    > img {
      margin-left: 100px;
      display: inline-flex;
      width: 100px;
      height: 100px;
    }
  }

  img {
    &.ilus {
      display: block;
      width: 100%;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1116px) {
    img {
      &.ilus {
        display: none;
      }
    }
  }
  @media screen and (min-width: 320px) and (max-width: 765px) {
    .card {
      padding: 15px;
    }
    .join {
      > img {
        display: none;
      }
    }
    .ilus {
      display: none;
    }
  }
`
